import { Stack } from '@mui/material';

import { AccordionWithHeading, Tablelike } from '../../../components/general';
import { capabilities, type ThemaFromThemaRouter, type Veranstaltung } from '../../../dtos.js';
import { getOnlineToolName, getRegionName, isOnlineVeranstaltung } from '../../../utils';
import { BlockungenTextStack } from '../BlockungenTextStack.js';
import { UpdateRessourcenBlockungen } from '../UpdateRessourcenBlockungen.js';
import {
  getLocationArtLabel,
  getLocationKuerzelLabel,
  getLocationLabel,
  getRaumartLabel,
  getStandortLabel,
} from './TerminLocationCard.utils.js';

type TerminLocationCardProps = {
  readonly thema: ThemaFromThemaRouter;
  readonly veranstaltung: Veranstaltung;
};

export const TerminLocationCard = ({ thema, veranstaltung }: TerminLocationCardProps) => {
  const canEditLocation = veranstaltung.capabilities.includes(capabilities.EDIT_LOCATION);

  if (isOnlineVeranstaltung(veranstaltung)) {
    return (
      <AccordionWithHeading heading="Veranstaltungslocation">
        <Tablelike rows={[['Meeting-Tool:', getOnlineToolName(veranstaltung) ?? '-']]} />
      </AccordionWithHeading>
    );
  }

  return (
    <AccordionWithHeading heading="Veranstaltungslocation">
      <Stack spacing={1}>
        {canEditLocation && <UpdateRessourcenBlockungen thema={thema} veranstaltung={veranstaltung} editType="raum" />}
        <Tablelike
          withDivider
          rows={[
            ['Region:', getRegionName(veranstaltung)],
            ['Standort:', getStandortLabel(veranstaltung)],
            ['Location:', getLocationLabel(veranstaltung)],
            ['Kürzel der Location:', getLocationKuerzelLabel(veranstaltung)],
            ['Location-Art:', getLocationArtLabel(veranstaltung)],
          ]}
        />
        {veranstaltung.raumBlockungen.map((raumBlockung) => (
          <Tablelike
            key={raumBlockung.raumSapId}
            withDivider
            rows={[
              ['Raum-Art:', <b key={raumBlockung.raumSapId}>{getRaumartLabel(raumBlockung.raum)}</b>],
              ['Raum-ID:', raumBlockung.raumSapId],
              ['Raum-Name:', raumBlockung.raum.name],
              ['Raum-Kürzel:', raumBlockung.raum.kuerzel],
              ['Raum-Größe:', raumBlockung.raum.groesse],
              ['Zeitraum:', <BlockungenTextStack key={raumBlockung.raumSapId} zeitraeume={raumBlockung.zeitraeume} />],
            ]}
          />
        ))}
      </Stack>
    </AccordionWithHeading>
  );
};
